import { Tabs } from 'antd';
import clsx from 'clsx';

import { FieldByType } from 'components';

import { useMemoState } from 'hooks';

import { enFields, frFields } from './lib';

export const RetailerDetails = ({
  enNotFilled,
  frNotFilled,
}: {
  enNotFilled: boolean;
  frNotFilled: boolean;
}) => {
  const [activeTab, setActiveTab] = useMemoState('1');

  const isEnRequired = enNotFilled && activeTab === '2';
  const isFRRequired = frNotFilled && activeTab === '1';

  return (
    <Tabs
      onChange={setActiveTab}
      activeKey={activeTab}
      items={[{
        key: '1',
        label: <span className={clsx(isEnRequired && 'text-[red]')}>1. English</span>,
        children: (
          enFields.map((field) => (
            <FieldByType
              key={field.label as string}
              field={field}
            />
          ))
        ),
      }, {
        key: '2',
        forceRender: true,
        label: <span className={clsx(isFRRequired && 'text-[red]')}>2. French</span>,
        children: (
          frFields.map((field) => (
            <FieldByType
              key={field.label as string}
              field={field}
            />
          ))
        ),
      }]}
    />
  );
};
